import React, { useState, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import axios from "axios";
import error from "../images/imagen-no-disponible.jpeg";
import "../css/Panel_Noticias.css";

const Panel_Noticias = () => {
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [noticias, setNoticias] = useState([]);
  const [selectedNoticia, setSelectedNoticia] = useState(null);

  const fetchNoticias = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/noticias.php`
    );

    const noticiasOrdenadas = [...response.data].sort((a, b) => {
      const fechaA =
        a.fecha && a.fecha !== "0000-00-00" ? new Date(a.fecha).getTime() : 0;
      const fechaB =
        b.fecha && b.fecha !== "0000-00-00" ? new Date(b.fecha).getTime() : 0;

      return fechaB - fechaA || b.id - a.id;
    });

    setNoticias(noticiasOrdenadas);
  };

  const handleBodyScroll = (isOpen) => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };

  useEffect(() => {
    handleBodyScroll(isModalOpen2);
    fetchNoticias();

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen2]);

  // Función corregida para parsear y convertir enlaces
  const renderTextoConEnlaces = (texto) => {
    if (!texto) return null;

    // RegEx para identificar URLs que inicien con http, https o www
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

    // Separamos el texto buscando coincidencias de URLs
    const partes = [];
    let lastIndex = 0;
    let match;

    while ((match = urlRegex.exec(texto)) !== null) {
      // Texto normal antes de la URL
      if (match.index > lastIndex) {
        partes.push(texto.substring(lastIndex, match.index));
      }

      let rawUrl = match[0];
      let cleanUrl = rawUrl;
      let trailingPunctuation = "";

      // Si la URL termina en signo de puntuación (ej: punto al final de oración), lo removemos de la URL
      const punctMatch = rawUrl.match(/[.,;:!?]+$/);
      if (punctMatch) {
        trailingPunctuation = punctMatch[0];
        cleanUrl = rawUrl.slice(0, -trailingPunctuation.length);
      }

      const href = cleanUrl.startsWith("http")
        ? cleanUrl
        : `https://${cleanUrl}`;

      partes.push(
        <React.Fragment key={match.index}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0066cc", textDecoration: "underline", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation(); // Evita que se cierre el modal
            }}
          >
            {cleanUrl}
          </a>
          {trailingPunctuation}
        </React.Fragment>
      );

      lastIndex = urlRegex.lastIndex;
    }

    // Texto restante después del último enlace
    if (lastIndex < texto.length) {
      partes.push(texto.substring(lastIndex));
    }

    return partes;
  };

  return (
    <div className="panelNoticias">
      <div className="noticias">
        {noticias.map((noticia) => (
          <div
            className="noticia"
            key={noticia.id}
            onClick={() => {
              setIsModalOpen2(true);
              setSelectedNoticia(noticia);
            }}>
            <div className="contenedorImagenNoticia">
              <img
                src={`${process.env.REACT_APP_API_URL}/uploads/${noticia.imagen}`}
                onError={(e) => (e.target.src = error)}
                loading="lazy"
                alt={noticia.titulo}
              />
            </div>
            <div className="textoNoticia">
              <h1>{noticia.titulo}</h1>
              {noticia?.fecha !== "0000-00-00" && <h2>{noticia?.fecha}</h2>}
              <p>{noticia.enunciado}</p>
            </div>
          </div>
        ))}
      </div>

      <CSSTransition
        in={isModalOpen2 && selectedNoticia !== null}
        timeout={300}
        classNames="modal"
        unmountOnExit>
        <div className="modal" onClick={() => setIsModalOpen2(false)}>
          <div
            className="modal-noticias"
            onClick={(e) => e.stopPropagation()}
            key={selectedNoticia?.id}>
            <h1>{selectedNoticia?.titulo}</h1>
            {selectedNoticia?.fecha !== "0000-00-00" && (
              <h2>{selectedNoticia?.fecha}</h2>
            )}
            <img
              src={`${process.env.REACT_APP_API_URL}/uploads/${selectedNoticia?.imagen}`}
              loading="lazy"
              alt={selectedNoticia?.titulo}></img>
            <div className="textoMiembro">
              <i>{selectedNoticia?.enunciado}</i>
              <p style={{ whiteSpace: "pre-line" }}>
                {renderTextoConEnlaces(selectedNoticia?.descripcion)}
              </p>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Panel_Noticias;